import * as React from 'react';
import {connect} from 'react-redux';
import {RootState} from '../../../../store';
import * as CommentsStore from '../../../../store/comments';
import * as ProjectsStore from '../../../../store/projects';
import * as CommonValuesStore from '../../../../store/common-values';
import {bindActionCreators} from 'redux';
import ProjectDetails from './ProjectDetails';
import ProjectStepper from './ProjectStepper';
import ProjectAssessments from './ProjectAssessments';
import {UserState} from 'redux-oidc';
import {match} from 'react-router';
import Loading from '../../../application/Loading';
import {ConnectedRouterProps} from 'connected-react-router';
import {ProjectStatus} from '../../../../store/projects/commonTypes';
import * as IncidentsStore from "../../../../store/incidents";
import IncidentsList from "../../../incident/list/IncidentsList";
import GoBackContainer from "../../../application/GoBackContainer";
import * as RuntimeStore from "../../../../store/runtime";

// At runtime, Redux will merge together...
type ProjectViewFormProps =
    ProjectsStore.ProjectsState
    & typeof ProjectsStore.actionCreators
    & { comments: CommentsStore.CommentsState }
    & typeof CommentsStore.actionCreators
    & IncidentsStore.IncidentsState
    & typeof IncidentsStore.actionCreators
    & CommonValuesStore.CommmonValuesState
    & typeof CommonValuesStore.actionCreators
    & typeof RuntimeStore.actionCreators
    & UserState
    & ConnectedRouterProps
    & { match: match<{ id: string }> };

class ProjectViewFormContainer extends React.PureComponent<ProjectViewFormProps> {
    // This method is called when the component is first added to the document
    public componentDidMount() {
        this.props.requestProject(this.props.match.params.id);
        this.props.requestProjectCertifications(this.props.match.params.id);
        this.props.requestProjectComments(this.props.match.params.id);
        this.props.ensureIncidentStatuses();
        this.props.requestIncidents(true);
    }

    private openIncidentDetails(number: string) {
        this.props.history.push(`/incidents/details/${number}`);
    }

    private openIncidentNewForm() {
        this.props.history.push('/incidents/new');
    }

    public render() {
        return (
            <React.Fragment>
                <GoBackContainer title="Prosjektsdetaljer" onGoBack={() => this.props.history.goBack()}>
                    {this.props.isLoading ? (
                        <Loading />
                    ) : (this.props.project ? (
                        <div>
                            {this.props.project.projectStatus != ProjectStatus.cancelled && (
                                <ProjectStepper project={this.props.project} className="mb-3 mt-3" />
                            )}
                            {this.props.project.projectStatus != ProjectStatus.onReview && (
                                <div className="mb-3 mt-3">
                                    {this.props.isCertificationsLoading ? (
                                        <Loading />
                                    ) : (
                                            <ProjectAssessments
                                                allowToAddReport={
                                                    this.props.certifications.filter(_ => _.statusId == 1).length == 0 && 
                                                    this.props.project.projectStatus != ProjectStatus.qaCompleted &&
                                                    this.props.project.projectStatus != ProjectStatus.cancelled
                                                }
                                                user={this.props.user!}
                                                showError={error => this.props.showNotification(error, "error")}
                                                certifications={this.props.certifications}
                                                onOpenCertification={(certificationId: string) => this.props.history.push(`/projects/details/${this.props.match.params.id}/assessment/${certificationId}`)}
                                                onOpenNewUploadForm={() => this.props.history.push(`/projects/details/${this.props.match.params.id}/assessment/report/new`)}
                                            />
                                        )
                                    }
                                </div>)}
                                <ProjectDetails project={this.props.project} className="mb-3 mt-3" />
                                <div className="mb-3 mt-3">
                                    <h4>Prosjektsaker</h4>
                                    <IncidentsList incidents={this.props.incidents ? this.props.incidents.filter(_ => _.projectId == this.props.project?.id) : []} incidentStatuses={this.props.incidentStatuses} onOpenDetails={(number) => this.openIncidentDetails(number)} onOpenNewForm={() => this.openIncidentNewForm()} />
                                </div>
                        </div>
                    ) : (
                            <span></span>
                        ))}
                </GoBackContainer>
            </React.Fragment>
        );
    }
}

export default connect(
    (state: RootState) => {
        const { projects, incidents, commonValues, oidc, comments, runtime } = state;
        return {
            ...projects,
            ...incidents,
            ...commonValues,
            ...oidc,
            ...runtime,
            comments: { ...comments }
        };
    },
    (dispatch) => {
        return {
            ...bindActionCreators(
                Object.assign(
                    {},
                    ProjectsStore.actionCreators,
                    CommentsStore.actionCreators,
                    CommonValuesStore.actionCreators,
                    IncidentsStore.actionCreators,
                    RuntimeStore.actionCreators
                ), dispatch)
        };
    }
)(ProjectViewFormContainer as any); // eslint-disable-line @typescript-eslint/no-explicit-any
